import { ChildEventProps } from '../../../../types';

export const shouldShowMoreOptions = (childEvents: ChildEventProps[]) =>
    childEvents.length > 5;
